import {
  Injectable
} from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import {
  MsAdalAngular6Service
} from 'microsoft-adal-angular6';
import {
  ApiService
} from '../services/api.service';
import {
  flatMap,
  map,
  switchMap,
  catchError
} from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private adal: MsAdalAngular6Service, private api: ApiService) {}

  intercept(req: HttpRequest < any > , next: HttpHandler) {
    // get api url from adal config
    // this.adal.logout(); return next.handle(req);

    return this.adal.acquireToken(req.url)
      .pipe(
        catchError((err) => {
            this.adal.login();
            return [];
            // return next.handle(req);
        }),
        switchMap((token) => {
          const authorizedRequest = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`),
          });
          return next.handle(authorizedRequest);
        }));
  }
}
